var LoginEnum = /* @__PURE__ */ ((LoginEnum2) => {
  LoginEnum2["LOGIN_BUTTON"] = "login--button";
  LoginEnum2["LOGIN_INPUT_CPF"] = "login--input-cpf";
  LoginEnum2["LOGIN_INPUT_PASSWORD"] = "login--input-password";
  LoginEnum2["LOGIN_SUBMIT_BUTTON"] = "login--submit-button";
  LoginEnum2["LOGIN_CLOSE_BUTTON"] = "login--close-button";
  LoginEnum2["LOGIN_REGISTER_LINK"] = "login--register-link";
  LoginEnum2["LOGIN_STEP"] = "login-div--login-step";
  LoginEnum2["PIN_INPUT_SLOT_0"] = "pin-input-slot-0";
  LoginEnum2["PIN_INPUT_SLOT_1"] = "pin-input-slot-1";
  LoginEnum2["PIN_INPUT_SLOT_2"] = "pin-input-slot-2";
  LoginEnum2["PIN_INPUT_SLOT_3"] = "pin-input-slot-3";
  LoginEnum2["PIN_INPUT"] = "pin-input";
  LoginEnum2["PIN_CONFIRMATION_TITLE"] = "confirmation-span--confirmation-step";
  return LoginEnum2;
})(LoginEnum || {});
export {
  LoginEnum
};
